import React from "react";
import { Link } from "react-router-dom";
import ClosedBadge from "./ClosedBadge";

// Renders a normal Link while the service is open, and a non-clickable card
// with a "Closed" badge while it is closed. The closed card mirrors the
// `.box_food a` layout so tiles keep the same size and spacing.
const ClosableLink = ({ closed, style, children, ...linkProps }) => {
  if (closed) {
    return (
      <div
        className={linkProps.className}
        style={{
          position: "relative",
          display: "inline-block",
          width: "100%",
          marginBottom: 16,
          cursor: "not-allowed",
          opacity: 0.85,
          ...style,
        }}
        aria-disabled="true"
        tabIndex={-1}
      >
        <ClosedBadge />
        {children}
      </div>
    );
  }

  return (
    <Link style={{ position: "relative", ...style }} {...linkProps}>
      {children}
    </Link>
  );
};

export default ClosableLink;
